import { NumericFacetRange, RangeSliderEventData } from '@models';
import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './range-slider-facet.component.hbs';

export class RangeSliderFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'rangeSliderFacet';
    protected override defaultHtml = defaultHtml;

    private get range(): NumericFacetRange | undefined {
        if (this.data?.range?.type === 'numeric') {
            return this.data.range;
        }

        return undefined;
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.range) {
            return '';
        }

        const range = Math.ceil(this.range.max) - Math.floor(this.range.min);

        const html = template({
            startValue: Math.floor(this.range.start),
            endValue: Math.ceil(this.range.end),
            minValue: Math.floor(this.range.min),
            maxValue: Math.ceil(this.range.max),
            sliderStart: Math.floor(((Math.floor(this.range.start) - Math.floor(this.range.min)) / range) * 100),
            sliderEnd: Math.ceil((Math.ceil(this.range.end) / range) * 100)
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-start]').forEach((e) => {
            e.addEventListener('blur', (event: Event) => {
                const element = event.currentTarget as HTMLInputElement;
                let value = parseFloat(element.value);

                if (isNaN(value)) {
                    value = 0;
                }

                this.setFacetValue(value, this.range!.end);
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-end]').forEach((e) => {
            e.addEventListener('blur', (event: Event) => {
                const element = event.currentTarget as HTMLInputElement;
                let value = parseFloat(element.value);

                if (isNaN(value)) {
                    value = 0;
                }

                this.setFacetValue(this.range!.start, value);
            });
        });

        this.shadowRoot?.querySelectorAll('hawksearch-range-slider').forEach((e) => {
            e.addEventListener('hawksearch:range-slider-dragging', ((event: CustomEvent): void => {
                const data: RangeSliderEventData = event.detail;
                const range = this.getRange(data.start, data.end);

                this.updateInputElements(range.start, range.end);
            }) as EventListener);

            e.addEventListener('hawksearch:range-slider-changed', ((event: CustomEvent): void => {
                const data: RangeSliderEventData = event.detail;
                const range = this.getRange(data.start, data.end);

                this.setFacetValue(range.start, range.end);
            }) as EventListener);
        });
    }

    private getRange(sliderStart: number, sliderEnd: number): { start: number; end: number } {
        const min = Math.floor(this.range!.min ?? 0);
        const max = Math.ceil(this.range!.max ?? 0);
        const range = max - min;
        const start = Math.floor((range * sliderStart) / 100 + min);
        const end = Math.ceil((max * sliderEnd) / 100);

        return { start: start, end: end };
    }

    private updateInputElements(start: number, end: number): void {
        const startElement = this.shadowRoot?.querySelector('[hawksearch-start]') as HTMLInputElement | null;
        const endElement = this.shadowRoot?.querySelector('[hawksearch-end]') as HTMLInputElement | null;

        if (startElement) {
            startElement.value = start.toString();
        }

        if (endElement) {
            endElement.value = end.toString();
        }
    }

    private setFacetValue(start: number, end: number): void {
        this.updateInputElements(start, end);

        if (start === Math.floor(this.range!.start) && end === Math.ceil(this.range!.end)) {
            return;
        }

        searchService.setFacetValue(this.data!.field!, `${start.toFixed(2)},${end.toFixed(2)}`);
    }
}
